module.exports = __webpack_public_path__ + "07_long_brown.5990a45f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/07_long_brown.png
// module id = jTnC
// module chunks = 0